// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import hourglass01Icon from "@/assets/icons/hourglass-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Hourglass01IconProps = Omit<IconProps, "name">;

export function Hourglass01Icon(props: Hourglass01IconProps): React.ReactNode {
  return <Icon name={hourglass01Icon} {...props} />;
}
